import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PartialId } from '@attain-apps/string-builder'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  query AgentChatWorkspace($tenantId: ID!, $zoneId: ID!, $id: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        agentChatWorkspace(id: $id) {
          id
          createdAt
          name
          description
          ownerId
          sharedWith
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.AgentChatWorkspaceQuery,
  ents.core.agent.Workspace | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'agentChatWorkspace',
      graphql.transformers.OUT.object({
        createdAt: graphql.transformers.OUT.validate(
          graphql.transformers.AWS_SCALARS.datetime,
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
        description: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeChecker.isNotNullish,
          { warnOnly: true },
        ),
        id: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          PartialId.assertIsPartialId,
        ),
        name: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeChecker.isNotNullish,
          { warnOnly: true },
        ),
        ownerId: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeAsserter.assertIsNotNullish,
        ),
        sharedWith: graphql.transformers.OUT.default(
          graphql.transformers.OUT.list(transformers.PASS_THROUGH),
          [],
        ),
      }),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.AgentChatWorkspaceQuery,
  ents.core.agent.Workspace | undefined,
  graphql.schema.AgentChatWorkspaceQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
